import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { scrollTo } from 'seamless-scroll-polyfill';
import { Icon } from './Icon';

interface PaginationProps {
  itemsPerPage: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  totalItemCount: number;
  page: number;
}

export function Pagination({
  itemsPerPage,
  setPage,
  totalItemCount,
  page,
}: PaginationProps) {
  const [itemsOffset, setItemsOffset] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(0);

  useEffect(() => {
    setPageCount(Math.ceil(totalItemCount / itemsPerPage));
  }, [itemsOffset, itemsPerPage, totalItemCount]);

  const handlePageClick = (event: { [key: string]: number }) => {
    const newOffset = (event.selected * itemsPerPage) % totalItemCount;
    setItemsOffset(newOffset);
  };

  const _scrollTop = () => {
    scrollTo(window, { behavior: 'smooth', top: 0, left: 0 });
    const adminMain = document.getElementById('admin-main');
    adminMain &&
      scrollTo(adminMain, {
        behavior: 'smooth',
        top: 0,
        left: 0,
      });
  };
  return (
    <div className="mx-auto mt-20 w-full max-w-7xl">
      <ReactPaginate
        breakLabel="..."
        breakClassName="pt-2.5"
        nextLabel={
          <div className="text flex flex-row items-center space-x-2 pt-2.5 text-gray-500">
            <span className="">Next</span>
            <Icon.ArrowRight />
          </div>
        }
        forcePage={page - 1}
        onPageChange={(e) => {
          _scrollTop();
          setPage(e.selected + 1);
          handlePageClick(e);
        }}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel={
          <div className="flex flex-row items-center space-x-2 pt-2.5 text-gray-500">
            <Icon.ArrowLeft />
            <span className="">Previous</span>
          </div>
        }
        renderOnZeroPageCount={undefined}
        activeClassName="text-blue-500 border-t-2 border-blue-500 px-4 pt-2"
        pageClassName="px-4 pt-[11px]"
        pageLinkClassName="extend-button-area"
        className="flex w-full justify-between border-t"
      />
    </div>
  );
}
